module.exports = __webpack_public_path__ + "static/img/24.c6f7fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/24.png
// module id = u7r1
// module chunks = 1